module.exports = __webpack_public_path__ + "img/B1.0397a815.svg";